import { defineStore } from "pinia";
import { ref } from "vue";

/**
 * AiNpc アシスタント（全タブ横断・AppBar 常駐）の状態。
 *
 * 会話は「ユーザーに付いて回る1つのアシスタント」として**単一の履歴**で保持し、
 * 送信時に現在の画面コンテキスト（tab/object_id）を毎回付与する。パネルの開閉や
 * ページ遷移をまたいでも履歴は維持される（コンポーネント破棄で消えない）。
 * ※ セッション内メモリのみ。ページ全体リロードでは消える（サーバー非保存）。
 */
export const useAiNpcAssistantStore = defineStore("aiNpcAssistant", () => {
  const messages = ref([]); // { role, content, streaming?, updates? }[]
  const open = ref(false);
  // AI が対象を編集したときのシグナル。各編集ビューが watch して自分の対象なら再読込する。
  const lastObjectUpdate = ref(null); // { tab, id, content_version?, changed_fields?, created?, ts }

  function clear() {
    messages.value = [];
  }

  function signalUpdate(payload) {
    lastObjectUpdate.value = { ...payload, ts: Date.now() };
  }

  return { messages, open, lastObjectUpdate, clear, signalUpdate };
});
